<template>
    <Header></Header>
    <ThankYou></ThankYou>
</template>

<script>
import ThankYou from '@/components/blocks/ThankYou.vue'
import Header from '@/components/Header.vue'
import {to_top} from "@/helper";

export default {
    components: {
        Header,
        ThankYou
    },
    mounted() {
        to_top()
    }
}
</script>
